import Vue from 'vue'
import _ from 'lodash'

export default {
    UPLOAD_ROOM_MEDIA: function(state, uploadObj/*{roomGroupId, filename, file}*/){
        state.uploadRoomMediaFiles.push(uploadObj);
    },
    CHANGE_UPLOAD_ROOM_MEDIA: function(state, changeInfo){
        let obj = state.uploadRoomMediaFiles.find(u => u.id === changeInfo.id);
        if(!obj){
            console.warn('upload obj is null', changeInfo);
            return;
        }
        Object.assign(obj, changeInfo);
        let percent = Math.round(obj.loaded * 100 / obj.total);
        if(isNaN(percent)){
            console.warn('calc percent :', obj.loaded, obj.total);
        }else{
            obj.percent = percent;
        }
    },
    REMOVE_UPLOAD_ROOM_MEDIA_FILE: function(state, uploadObj) {
        let idx = state.uploadRoomMediaFiles.findIndex(u => u.id === uploadObj.id);
        if(idx > -1) {
            state.uploadRoomMediaFiles.splice(idx, 1)
        }
    },
    ADD_ROOM_MEDIA_FILE: function(state, data){
        let {roomMediaFile} = data;
        const addMediaFile = (roomMediaFile) => {
            let prev = this.getters['media/getRoomMediaFile'](roomMediaFile);
            if(prev){
                _.merge(prev, roomMediaFile);
            }else{
                let roomMedia = this.getters['media/getRoomMedia'](roomMediaFile.roomGroupId);
                roomMedia.roomMediaFiles.push(roomMediaFile);
            }
        }
        if(Array.isArray(roomMediaFile)) {
            roomMediaFile.forEach(addMediaFile)
        } else {
            addMediaFile(roomMediaFile)
        }
    },

    REMOVE_ROOM_MEDIA_FILE: function(state, data){
        let {roomGroupId, mediaId} = data;
        let roomMedia = this.getters['media/getRoomMedia'](roomGroupId);
        if(!roomMedia) return;

        let idx = roomMedia.roomMediaFiles.findIndex(roomMediaFile => roomMediaFile.mediaId == mediaId);
        if(idx < 0){
            return;
        }
        roomMedia.roomMediaFiles.splice(idx, 1);

        if(roomMedia.mediaId == mediaId) {
            roomMedia.mediaId = null;
        }
    },
    CHANGE_ROOM_MEDIA: function(state, data){
        let {roomMedia} = data;
        let rm = this.getters['media/getRoomMedia'](roomMedia.roomGroupId);
        if(!rm) return;

        rm.mediaId = roomMedia.mediaId;
        rm.playState = roomMedia.playState;
        rm.currentPlayTime = roomMedia.currentPlayTime;
        rm.lastPlayDate = roomMedia.lastPlayDate;
        rm.playType = roomMedia.playType;

        state.init = true;
    },
    PLAY_ROOM_MEDIA: function(state, data){
        let {roomGroupId, mediaId, seekTime} = data;
        let roomMedia = this.getters['media/getRoomMedia'](roomGroupId);
        if(!roomMedia) return;
        if(roomMedia.mediaId !== mediaId) return;

        roomMedia.playState = 'play';
        roomMedia.seekTime = seekTime;
    },
    PAUSE_ROOM_MEDIA: function(state, data){
        let {roomGroupId, seekTime} = data;
        let roomMedia = this.getters['media/getRoomMedia'](roomGroupId);
        if(!roomMedia) return;

        roomMedia.playState = 'paused';
        roomMedia.seekTime = seekTime;
    }
}
